import { borderRadius } from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const Fallback = styled.span<{ $customSize: number }>`
  color: var(--text-default);
  background-color: var(--surface-default);
  ${borderRadius.r05};
  padding: 8px;
  min-height: ${({ $customSize }) => `${$customSize}px`};
`;

export const Flag = styled.span<{
  $variant: 'default' | 'rounded' | 'circular';
  $customSize: number;
}>`
  display: inline-block !important;
  background-size: contain !important;
  background-position: 50% 50% !important;
  background-repeat: no-repeat !important;
  vertical-align: middle;
  box-sizing: border-box;
  flex-shrink: 0;

  /* Apply custom size - height is always customSize */
  height: ${({ $customSize }) => `${$customSize}px`} !important;

  /* Width depends on variant */
  ${({ $variant, $customSize }) =>
    $variant === 'circular'
      ? css`
          width: ${$customSize}px !important;
        `
      : css`
          width: ${$customSize * 1.5}px !important;
        `}

  ${({ $variant }) =>
    $variant === 'rounded' &&
    css`
      ${borderRadius.r2};
      overflow: hidden;
    `}

  ${({ $variant }) =>
    $variant === 'circular' &&
    css`
      border-radius: 50%;
      overflow: hidden;
      background-clip: border-box;
      background-size: contain !important;
      background-position: 50% !important;
    `}
`;
